import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import { TipoCampoFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';
import {
  ConfiguracionTablaAsincrona,
  TipoColumnaTabla,
} from 'src/app/compartido/tabla/utilidades/tabla.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';
import { EstadoOrden } from 'src/app/ordenes/utilidades/ordenes.models';

/* Configuración de la ficha de recoger órdenes */
export const CONFIGURACION_FICHA_RECOGER_ORDENES: ConfiguracionFicha = {
  header: { titulo: 'Recoger Órdenes', icono: Icono.RECOGIDA },
  maxWidth: 1000,
};

/* Configuración de la tabla de recoger órdenes */
export const CONFIGURACION_TABLA_RECOGER_ORDENES: ConfiguracionTablaAsincrona =
  {
    columnas: [
      { slug: 'id', nombre: 'ID Orden' },
      { slug: 'titulo', nombre: 'Titulo' },
      { slug: 'referencia', nombre: 'N° Referencia' },
      {
        slug: 'fecha_preparacion',
        nombre: 'Fecha Preparación',
        tipo: TipoColumnaTabla.FECHA,
        ordenable: true,
      },
    ],
    busqueda: true,
    filtros: [
      {
        nombre: 'Organización',
        slug: 'organizacion',
        tipo: TipoCampoFormulario.NUMERO,
        oculto: true,
      },
      {
        nombre: 'Sin Domicilio',
        slug: 'sin_domicilio',
        tipo: TipoCampoFormulario.BOOLEANO,
        valor: false,
        oculto: true,
      },
      {
        nombre: 'Estado',
        slug: 'estado',
        tipo: TipoCampoFormulario.TEXTO,
        oculto: true,
        valor: EstadoOrden.PREPARADA,
      },
    ],
    acciones: [
      {
        nombre: 'Recoger',
        slug: 'recoger',
        icono: Icono.RECOGIDA,
      },
    ],
    botones: [
      {
        nombre: 'Escanear Etiquetas',
        slug: 'puntear',
        icono: Icono.ESCANEAR,
      },
    ],
    omitirCargaInicial: true,
  };
